// import React, { useState, useEffect } from 'react';

// const Industries = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [arrowAnimation, setArrowAnimation] = useState(false);
  
//   const serviceSlides = [
   
//     [
//     {
//         title: " Automotive industry ",
//         bgColor: "#47d5eb", // Dark Teal
//         hoverColor: "#3C7B85",
//         textColor: "#FFFFFF",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/17%202.png?updatedAt=1740727668896",
//       },
      
//       {
//         title: "Industrial manufacturing",
//         bgColor: "white", // Turquoise
//         hoverColor: "white",
//         textColor: "#4ECDC4",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/23%20(1).png?updatedAt=1740727668168",
//       },
//       {
//         title: "Aerospace and Defense ",
//         bgColor: "white",
//         hoverColor: "white",
//         textColor: "#FFFFFF",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/16.png?updatedAt=1740727667345",
//       },
//       {
//         title: "Food and Beverages",
//         bgColor: "#FFA630", // Warm Orange
//         hoverColor: "#FFB847",
//         textColor: "#FFFFFF",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/22%20(2).png?updatedAt=1740727666646",
//       }
//     ],
//     [
//       {
//         title: "Textile Industries",
//         bgColor: "#45B29D", // Mint Green
//         hoverColor: "#67C9B4",
//         textColor: "#FFFFFF",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/21%20(2).png?updatedAt=1740727666183",
//       },
//       {
//         title: "High Tech and Electronics",
//         bgColor: "white", // Golden Yellow
//         hoverColor: "white",
//         textColor: "#EFC94C",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/18%20(1).png?updatedAt=1740727664742",
//       },
//       {
//         title: "Construction & Engineering",
//         bgColor: "white", // Reddish Orange
//         hoverColor: "white",
//         textColor: "#E27A3F",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/19%202.png?updatedAt=1740727662773",
//       },
//       {
//         title: "Logistics and Distribution",
//         bgColor: "#9D4EDD", // Vivid Purple
//         hoverColor: "#B36DFF",
//         textColor: "#FFFFFF",
//         imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/20%20(3).png?updatedAt=1740727662559",
//       }
//     ]
//   ];

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % serviceSlides.length);
//     animateArrow("right");
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + serviceSlides.length) % serviceSlides.length);
//     animateArrow("left");
//   };

//   const animateArrow = (direction) => {
//     setArrowAnimation(direction);
//     setTimeout(() => setArrowAnimation(false), 500);
//   };

//   // Get current set of services
//   const currentServices = serviceSlides[currentSlide];
  
//   return (
//     <div className='w-full'
//     style={{ background: 'linear-gradient(135deg, #F7F9FC, #E4ECF7)' }}
//     >
//        <div
//       className="w-full max-w-6xl mx-auto px-4 sm:px-6 py-16 relative"
      
//     >
//       {/* Header section */}
//       {/* <div className=" mb-12">
//         <h2 className="text-md  font-bold mb-1" style={{ color: "#691883" }}>
        
//         </h2>
//         <p className="max-w-2xl   md:text-lg" style={{ color: "#0d3a79" }}>
         
//         </p>
//         </div>
//          */}

//           <div style={{ marginBottom: '32px' }}>
//         <h2 style={{ color: '#691883', fontSize: '18px', marginBottom: '8px', fontWeight: 500 }}> Industries we serve</h2>
//         <h1 style={{ color: '#0f172a', fontSize: '22px', marginBottom: '16px', fontWeight: 600 }}> Explore Our Industry-Specific  <span className='text-[#E27A3F] text-md'>ERP Managed Services and Cloudsuite Solutions. </span> </h1>
//         <p style={{ color: '#4b5563', fontSize: '16px', maxWidth: '700px' }}>In Today’s Fast-paced Business Environment, Where Efficiency and Adaptability are Key, KCS Tech Empowers Your Organization with Customized Cloud-Based ERP Solutions That Streamline Operations, Enhance Decision-Making, And Drive Sustainable Growth.</p>
//       </div>
    
//       {/* Services section with carousel */}
//       <div className="relative">
//         {/* Carousel navigation buttons - positioned at top right */}
//         <div className="flex items-center space-x-2 absolute top-0 right-0 z-10 -mt-12">
//           <button
//             onClick={prevSlide}
//             className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shadow-md"
//             style={{
//               backgroundColor: "#FFFFFF",
//               color: "#FF6B6B",
//               border: "1px solid #E5E7EB"
//             }}
//             onMouseOver={(e) => {
//               e.currentTarget.style.backgroundColor = "#691883";
//               e.currentTarget.style.color = "#FFFFFF";
//             }}
//             onMouseOut={(e) => {
//               e.currentTarget.style.backgroundColor = "white";
//               e.currentTarget.style.color = "#691883";
//             }}
//           >
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//               style={{
//                 transform: arrowAnimation === "left" ? "translateX(-3px)" : "translateX(0)",
//                 transition: "transform 0.3s ease-in-out"
//               }}
//             >
//               <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//             </svg>
//           </button>
//           <button
//             onClick={nextSlide}
//             className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shadow-md"
//             style={{
//               backgroundColor: "#691883",
//               color: "#FFFFFF"
//             }}
//             onMouseOver={(e) => {
//               e.currentTarget.style.backgroundColor = "##691883";
//             }}
//             onMouseOut={(e) => {
//               e.currentTarget.style.backgroundColor = "#691883";
//             }}
//           >
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//               style={{
//                 transform: arrowAnimation === "right" ? "translateX(3px)" : "translateX(0)",
//                 transition: "transform 0.3s ease-in-out"
//               }}
//             >
//               <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//             </svg>
//           </button>
//         </div>

//         {/* Services grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
//           {currentServices.map((service, index) => (
//             <div
//               key={index}
//               className="flex border overflow-hidden h-44 md:h-52 transition-all duration-300 hover:shadow-xl"
//               style={{ borderColor: "#E5E7EB" }}
//             >
//               <div
//                 className="p-4 md:p-6 flex flex-col justify-center w-2/5 transition-colors duration-300"
//                 style={{
//                   backgroundColor: service.bgColor,
//                   color: service.textColor,
//                 }}
//                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = service.hoverColor}
//                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = service.bgColor}
//               >
//                 <h3 className="text-lg md:text-xl font-bold mb-4">{service.title}</h3>
//                 <div className="text-2xl font-light arrow-container">
//                   <svg
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="arrow-icon"
//                   >
//                     <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                   </svg>
//                 </div>
//               </div>
//               <div className="w-3/5">
//                 <img src={service.imageUrl} alt={service.title} className="w-full h-full object-cover" />
//               </div>
//             </div>
//           ))}
//         </div>
        
//         {/* Carousel indicators */}
//         <div className="flex justify-center space-x-2 mt-8">
//           {serviceSlides.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentSlide(index)}
//               className="w-2.5 h-2.5 rounded-full transition-all duration-300"
//               style={{
//                 backgroundColor: currentSlide === index ? "#691883" : "#D1D5DB",
//                 transform: currentSlide === index ? "scale(1.2)" : "scale(1)"
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       {/* CSS for subtle arrow animation on hover */}
//       <style jsx>{`
//         .arrow-container {
//           position: relative;
//           overflow: hidden;
//         }
//         .arrow-icon {
//           transition: transform 0.3s ease-in-out;
//         }
//         .arrow-container:hover .arrow-icon {
//           transform: translateX(5px);
//         }
//       `}</style>
//     </div>
//     </div>
//   );
// };

// export default Industries;


import React, { useState, useEffect } from 'react';

const Industries = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [arrowAnimation, setArrowAnimation] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const serviceSlides = [
    [
      {
        title: "Automotive Industry",
        bgColor: "#2D3748",
        hoverColor: "#4A5568",
        textColor: "#FFFFFF",
        accentColor: "#47D5EB",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/17%202.png?updatedAt=1740727668896",
        description: "Advanced manufacturing solutions for automotive excellence"
      },
      {
        title: "Industrial Manufacturing",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#4ECDC4",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/23%20(1).png?updatedAt=1740727668168",
        description: "Streamlined operations for industrial growth"
      },
      {
        title: "Aerospace & Defense",
        bgColor: "#1A202C",
        hoverColor: "#2D3748",
        textColor: "#FFFFFF",
        accentColor: "#E53E3E",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/16.png?updatedAt=1740727667345",
        description: "Mission-critical solutions for aerospace"
      },
      {
        title: "Food & Beverages",
        bgColor: "#FFA630",
        hoverColor: "#FF8C00",
        textColor: "#FFFFFF",
        accentColor: "#FFD700",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/22%20(2).png?updatedAt=1740727666646",
        description: "Quality assurance for food industry"
      }
    ],
    [
      {
        title: "Textile Industries",
        bgColor: "#45B29D",
        hoverColor: "#38A169",
        textColor: "#FFFFFF",
        accentColor: "#68D391",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/21%20(2).png?updatedAt=1740727666183",
        description: "Innovative textile manufacturing solutions"
      },
      {
        title: "High Tech & Electronics",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#EFC94C",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/18%20(1).png?updatedAt=1740727664742",
        description: "Cutting-edge technology solutions"
      },
      {
        title: "Construction & Engineering",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#E27A3F",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/19%202.png?updatedAt=1740727662773",
        description: "Building the future with smart solutions"
      },
      {
        title: "Logistics & Distribution",
        bgColor: "#9D4EDD",
        hoverColor: "#805AD5",
        textColor: "#FFFFFF",
        accentColor: "#B794F6",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/20%20(3).png?updatedAt=1740727662559",
        description: "Optimized supply chain management"
      }
    ]
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % serviceSlides.length);
    animateArrow("right");
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + serviceSlides.length) % serviceSlides.length);
    animateArrow("left");
  };

  const animateArrow = (direction) => {
    setArrowAnimation(direction);
    setTimeout(() => setArrowAnimation(false), 500);
  };

  const currentServices = serviceSlides[currentSlide];
  
  return (
    <div 
      className="w-full min-h-screen relative overflow-hidden"
      style={{ 
        background: '#FFFFFF',
      }}
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute top-20 left-10 w-32 h-32 rounded-full"
          style={{ 
            background: 'linear-gradient(45deg, #FF6B6B, #4ECDC4)',
            animation: 'float 6s ease-in-out infinite'
          }}
        />
        <div 
          className="absolute top-40 right-20 w-24 h-24 rounded-full"
          style={{ 
            background: 'linear-gradient(45deg, #FFE66D, #FF6B6B)',
            animation: 'float 8s ease-in-out infinite reverse'
          }}
        />
        <div 
          className="absolute bottom-20 left-1/4 w-40 h-40 rounded-full"
          style={{ 
            background: 'linear-gradient(45deg, #4ECDC4, #45B29D)',
            animation: 'float 10s ease-in-out infinite'
          }}
        />
      </div>

      <div 
        className={`w-full max-w-7xl mx-auto px-4 sm:px-6 py-6 relative z-10 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Header Section */}
        <div className="text-center mb-16">
          <div 
            className="inline-block px-6 py-2 rounded-full mb-6"
            style={{ 
              background: '#691883',
              color: '#FFFFFF'
            }}
          >
            <h2 className="text-lg font-medium text-white text-center">Industries We Serve</h2>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" style={{ color: '#0f172a' }}>
            Explore Our Industry-Specific
            <br />
            <span 
              className="text-transparent bg-clip-text text-4xl md:text-5xl"
              style={{ 
                backgroundImage: 'linear-gradient(135deg, #E27A3F 0%, #691883 100%)'
              }}
            >
              ERP Managed Services
            </span>
          </h1>
          
          <p className="text-lg max-w-4xl mx-auto leading-relaxed" style={{ color: '#4b5563' }}>
            In today's fast-paced business environment, where efficiency and adaptability are key, 
            KCS Tech empowers your organization with customized cloud-based ERP solutions that 
            streamline operations, enhance decision-making, and drive sustainable growth.
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center mb-12">
          <div className="flex items-center space-x-4">
            <button 
              onClick={prevSlide}
              className="group w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              style={{ 
                background: '#F7FAFC',
                border: '2px solid #E2E8F0',
                color: '#691883'
              }}
            >
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-transform duration-300 ${
                  arrowAnimation === "left" ? "rotate-45" : ""
                } group-hover:rotate-45`}
              >
                <path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <div className="flex space-x-2">
              {serviceSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className="transition-all duration-300 hover:scale-125"
                  style={{ 
                    width: currentSlide === index ? '32px' : '12px',
                    height: '12px',
                    borderRadius: '6px',
                    background: currentSlide === index 
                      ? 'linear-gradient(135deg, #E27A3F 0%, #691883 100%)'
                      : '#E2E8F0',
                  }}
                />
              ))}
            </div>
            
            <button 
              onClick={nextSlide}
              className="group w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              style={{ 
                background: 'linear-gradient(135deg, #E27A3F 0%, #691883 100%)',
                boxShadow: '0 8px 32px rgba(105, 24, 131, 0.3)',
                color: '#FFFFFF'
              }}
            >
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-transform duration-300 ${
                  arrowAnimation === "right" ? "rotate-45" : ""
                } group-hover:rotate-45`}
              >
                <path d="M12 5V19M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {currentServices.map((service, index) => (
            <div 
              key={index} 
              className="group relative overflow-hidden rounded-2xl transition-all duration-500 hover:scale-105 hover:-translate-y-2"
              style={{ 
                background: '#FFFFFF',
                border: '1px solid #E2E8F0',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                height: '320px',
                animation: `slideUp 0.6s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Image Section */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.imageUrl} 
                  alt={service.title} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                />
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ 
                    background: `linear-gradient(135deg, ${service.accentColor}20, ${service.bgColor === '#FFFFFF' ? '#F7FAFC' : service.bgColor}40)`
                  }}
                />
              </div>

              {/* Content Section */}
              <div className="p-6 relative">
                <div 
                  className="absolute top-0 left-0 w-16 h-1 transition-all duration-300 group-hover:w-full"
                  style={{ background: service.accentColor }}
                />
                
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl font-bold transition-colors duration-300" style={{ color: '#2D3748' }}>
                    {service.title}
                  </h3>
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 group-hover:rotate-45 group-hover:scale-110"
                    style={{ 
                      background: `linear-gradient(135deg, ${service.accentColor}, ${service.hoverColor === '#FFFFFF' ? '#F7FAFC' : service.hoverColor})`
                    }}
                  >
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-white"
                    >
                      <path d="M12 5V19M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                
                <p className="text-sm leading-relaxed" style={{ color: '#718096' }}>
                  {service.description}
                </p>
              </div>

              {/* Hover Effect Overlay */}
              <div 
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{ 
                  background: `linear-gradient(135deg, ${service.accentColor}05, transparent)`
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .group:hover .group-hover\\:animate-pulse {
          animation: pulse 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default Industries;